import { Component } from '@angular/core';
import { GamesGroupService, IPollQuestion, PopulationQuery } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-polls-v2-page',
  templateUrl: './polls-v2-page.component.html',
  styleUrl: './polls-v2-page.component.scss',
})
export class PollsV2PageComponent {
  pollsQuestion$: Observable<IPollQuestion[]>;
  isKid: boolean;
  constructor(private gamesGroupService: GamesGroupService, private populationQuery: PopulationQuery) {}

  ngOnInit(): void {
    this.isKid = this.populationQuery.userInPopulation(['Kids']);
    this.pollsQuestion$ = this.gamesGroupService.fetchPolls();
  }
}
